import styled from 'styled-components';

export const Main = styled.div<{ displayFilterSection: boolean | undefined }>`
  display: grid;
  grid-auto-columns: auto 5fr;
`;

export const FilterWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    grid-column: 1;
  }
`;

export const ProductListingWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    grid-column: 2;
  }
`;

export const FilterSection = styled.div`
  margin-right: 10px;
  border-radius: 5px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin: 0 auto;
  }
`;

export const FilterSectionSticky = styled(FilterSection)`
  position: sticky;
  top: 200px;
`;
